/**
 * External dependencies
 */
import {
	ColumnControl,IconControl, IconDisplay, URLInputControl 
} from '~cartzillagb/components'
import {
	withTabbedInspector,
} from '~cartzillagb/higher-order'
import classnames from 'classnames'
import { getBootstrapClasses, range } from '~cartzillagb/util'
import { i18n } from 'cartzillagb'

/**
 * WordPress dependencies
 */
import {
	PanelBody, ToggleControl, RangeControl 
} from '@wordpress/components'
import { __ } from '@wordpress/i18n'
import { RichText } from '@wordpress/block-editor'
import { addFilter, applyFilters } from '@wordpress/hooks'
import { Fragment } from '@wordpress/element'
import { compose } from '@wordpress/compose'

addFilter( 'cartzillagb.contact-details.edit.inspector.style.before', 'cartzillagb/contact-details', ( output, props ) => {
	const { attributes, setAttributes } = props
	const {
		enableContainer,
		limit,
		lgColumns,
		mdColumns,
		smColumns,
		listlimit,
		mapicon,
		maplink,
	} = attributes

	return (
		<Fragment>
			<PanelBody title={ __( "General Settings", i18n ) } initialOpen={ true }>
				<ToggleControl
					label={ __( 'Enable Container', i18n ) }
					checked={ enableContainer }
					onChange={ enableContainer => setAttributes( { enableContainer } ) }
				/>
				<RangeControl
					label={ __( 'Limit' ) }
					value={ limit }
					onChange={ limit => setAttributes( { limit } ) }
					min={ 1 }
					max={ applyFilters( 'cartzillagb.contact-details.edit.inspector.max.limit', 12 ) }
				/>
				{ ( ( (limit % 4 ) === 3 ) || ( (limit % 4 ) === 0 ) ) &&
					<RangeControl
						label={ __( 'List Limit' ) }
						value={ listlimit }
						onChange={ listlimit => setAttributes( { listlimit } ) }
						min={ 1 }
						max={ applyFilters( 'cartzillagb.contact-details.edit.inspector.max.listlimit', 6 ) }
					/>
				}
				<ColumnControl
					label={ __("Column Width", i18n ) }
					lgColumns={ lgColumns }
					lgMin={ 1 }
					lgMax={ 12 }
					mdColumns={ mdColumns }
					mdMin={ 1 }
					mdMax={ 12 }
					smColumns={ smColumns }
					smMin={ 1 }
					smMax={ 12 }
					onChangelg={ value => setAttributes( { lgColumns: value } ) }
					onChangemd={ value => setAttributes( { mdColumns: value } ) }
					onChangesm={ value => setAttributes( { smColumns: value } ) }
				/>
				<IconControl
					label={ __( 'Link Icon', i18n ) }
					value={ mapicon || 'czi-arrow-right' }
					onChange={ mapicon => setAttributes( { mapicon } ) }
				/>
				<URLInputControl
					label={ __( 'Map Link', i18n ) }
					value={ maplink }
					onChange={ maplink => setAttributes( { maplink } ) }
				/>
			</PanelBody>
			<PanelBody title={ __( 'Icon Settings', i18n ) }>
				<div className="icon-control-componet-wrapper">
					{ range( 1, limit + 1 ).map( i => {
						let defaulticon =''
						if ( (i % 4 ) === 1 ) {
							defaulticon='czi-location' 
						}

					   if ( (i % 4 ) === 2 ) {
							defaulticon='czi-time'
						}

						if ( (i % 4 ) === 3 ) {
							defaulticon='czi-phone'
						}
						if ( (i % 4 ) === 0 ) {
							defaulticon='czi-mail'
						}

						const Icon = attributes[ `icon${ i }` ]

						return (
							<IconControl 
								key={ i }
								label={ __( `Icon #${ i }`, i18n ) }
								value={ Icon || defaulticon }
								onChange={ Icon => setAttributes( { [ `icon${ i }` ]: Icon } ) }
							/>
						)
					} ) }
				</div>
			</PanelBody>
		</Fragment>
	)
} )

const edit = props => {
	const {
		setAttributes, className, attributes,
	} = props

	const {
		enableContainer,
		listlimit,
		limit,
		desc,
		linktext,
		list1,
		list2,
		lgColumns,
		mdColumns,
		smColumns,
		mapicon,
		maplink,
	} = attributes

	const mainClasses = classnames( [
		'pt-grid-gutter',
		className,
		enableContainer ? 'container-fluid' : '',
	], applyFilters( 'cartzillagb.contact-details.main-block.classes', {}, props ) )


	const content = range( 1, ( limit ) + 1 ).map( i => {

		const Heading = attributes[ `heading${ i }` ]
		const Icon = attributes[ `icon${ i }` ]

		let defaultheading =''
		let defaulticon =''
		let defaultheadingclass =''

		if ( (i % 4 ) === 1 ) {
			defaultheading=(__("Main store address", i18n))
			defaulticon='czi-location'
			defaultheadingclass='h6 mb-2'
		}

		if ( (i % 4 ) === 2 ) {
			defaultheading=(__("Working hours", i18n))
			defaulticon='czi-time'
			defaultheadingclass='h6 mb-3'
		}

		if ( (i % 4 ) === 3 ) {
			defaultheading=(__("Phone numbers", i18n))
			defaulticon='czi-phone'
			defaultheadingclass='h6 mb-3'
		}
		if ( (i % 4 ) === 0 ) {
			defaultheading=(__("Email addresses", i18n))
			defaulticon='czi-mail'
			defaultheadingclass='h6 mb-3'
		}       

		const headingComp = (
			<RichText
				tagName='h3'
				value={ Heading || defaultheading }
				className={ defaultheadingclass }
				onChange={ Heading => setAttributes( { [ `heading${ i }` ]: Heading } ) }
				placeholder={ __( 'Heading' ) }
				keepPlaceholderOnFocus
			/>
		)

		const descComp = (
			<RichText
				tagName='p'
				value={ desc || "396 Lillian Blvd, Holbrook, NY 11741, USA" }
				className="font-size-sm text-muted"
				onChange={ desc => setAttributes( { desc } ) }
				placeholder={ __( 'desc' ) }
				keepPlaceholderOnFocus
			/>
		)

		const linktextComp = (
			<RichText
				tagName='span'
				value={ linktext || "Click to see map" }
				className="font-size-sm text-primary"
				onChange={ linktext => setAttributes( { linktext } ) }
				placeholder={ __( 'linktext' ) }
				keepPlaceholderOnFocus
			/>
		)

		const liComp1 = (
			<RichText
				tagName='li'
				value={ list1 || 'Mon - Fri: 10AM - 7PM' }
				onChange={ list1 => setAttributes( { list1 } ) }
				placeholder={ __( 'list1' ) }
				keepPlaceholderOnFocus
			/>
		)

		const liComp2 = (
			<RichText
				tagName='li'
				value={ list2 || 'Sta: 11AM - 5PM' }
				className="mb-0"
				onChange={ list2 => setAttributes( { list2 } ) }
				placeholder={ __( 'list2' ) }
				keepPlaceholderOnFocus
			/>
		)

		const iconComp = (
			<IconDisplay 
				value={ Icon || defaulticon }
				additionalClass="h3 mt-2 mb-4 text-primary"
			/>    
		)

		const linkiconComp = (
			<IconDisplay 
				value={ mapicon || 'czi-arrow-right' }
				additionalClass="align-middle ml-1"
			/>    
		)

		let style = ''

		if ( (i % 4 ) === 1 ) {
			style = (
				<a className="card" href="javascript:void(0)">
					<div className="card-body text-center">
						{ iconComp }
						{ headingComp }
						{ descComp }
						<div className="locationlink">
							{ linktextComp }
							{ linkiconComp }
						</div>
					</div>
				</a>
			)
		}

		if ( (i % 4 ) === 2 ) {
			style = (
				<div className="card">
					<div className="card-body text-center">
						{ iconComp }
						{ headingComp }
						<ul className="list-unstyled font-size-sm text-muted mb-0">
							{ liComp1 }
							{ liComp2 }
						</ul>
					</div>
				</div>
			)
		}

		if( ( (i % 4 ) === 3 ) || ( (i % 4 ) === 0 ) ) {
			style = (
				<div className="card">
					<div className="card-body text-center">
						{ iconComp }
						{ headingComp }
						<ul className="list-unstyled font-size-sm mb-0">
					    { range( 1, listlimit + 1 ).map( j => { 
							const liClasses = classnames( [
								( listlimit === j ) && 'mb-0',
							], 
							applyFilters( 'cartzillagb.contact-details.liclasses', {}, props ) )

							let defaultcontactlist =''
							let defaultcontactlink =''
							
							if ( ( (i % 4 ) === 3 ) && ( (j % 2 ) === 1 ) ) {
								defaultcontactlist=(__("For customers: ", i18n))
								defaultcontactlink=(__("+1 (080) 44 357 260", i18n))
							}
							if ( ( (i % 4 ) === 3 ) && ( (j % 2 ) === 0 ) ) {
								defaultcontactlist=(__("Tech customers: ", i18n))
								defaultcontactlink=(__("+1 00 33 169 7720", i18n))
							}

							if ( ( (i % 4 ) === 0 ) && ( (j % 2 ) === 1 ) ) {
								defaultcontactlist=(__("For customers: ", i18n))
								defaultcontactlink=(__("customer@example.com", i18n))
							}
							if ( ( (i % 4 ) === 0 ) && ( (j % 2 ) === 0 ) ) {
								defaultcontactlist=(__("Tech customers: ", i18n))
								defaultcontactlink=(__("support@example.com", i18n))
							}

							const contactlink       = attributes[ `contactlink${ i }${ j }` ]
							const contactlist       = attributes[ `contactlist${ i }${ j }` ]
						
							const contactlistComp = (
								<RichText
									tagName='span'
									value={ contactlist || defaultcontactlist }
									className="text-muted mr-1"
									onChange={ contactlist => setAttributes( { [ `contactlist${ i }${ j }` ]: contactlist } ) }
									placeholder={ __( 'contactlist' ) }
									keepPlaceholderOnFocus
								/>
							)
							const contactlinkComp = (
								<RichText
									tagName='span'
									value={ contactlink || defaultcontactlink }
									className="nav-link-style"
									onChange={ contactlink => setAttributes( { [ `contactlink${ i }${ j }` ]: contactlink } ) }
									placeholder={ __( 'contactlink' ) }
									keepPlaceholderOnFocus
								/>
							)

							return (
								<li className={ liClasses } key={ i }>
								   { contactlistComp }
								   { contactlinkComp }
								</li>
							) 
						} ) }
						</ul>
					</div>
				</div>
			)
		}

	

		const bootstrapClass = getBootstrapClasses( undefined, smColumns, mdColumns, lgColumns )

		const output = (
			<div className={ `${ bootstrapClass } mb-grid-gutter` }  key={ i }>
				{ style }
			</div>
		)
		return output
	} )
		
	return (
		<div className={ mainClasses }>
			<div className="row">
				{ content }
			</div>
		</div>
	)  
}

export default compose(
	withTabbedInspector( [ 'style', 'advanced' ] ),
)( edit )